import React from 'react'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification, Modal } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { list, find, save, remove, importData } from '../../services/address'

function* fetchAddresssRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchAddresss'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_ADDRESS,
    result,
  })
}

function* fetchAddresss({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = null // JSON.parse(localStorage.getItem('fetchAddresss'))
    if (fe != null) {
      size = fe.size || localStorage.getItem('pageSize') || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchAddresss', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_ADDRESS,
    result,
  })
}

function* fetchAddressEdit({ id, openModal }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id, openModal)
  yield put({
    type: actions.EDIT_ADDRESS,
    result,
    openModal,
  })
}

function* fetchAddressSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  console.log('fetchAddressSave result', result)
  yield put({
    type: actions.SAVE_ADDRESS_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_ADDRESSS,
  })
}

function* fetchAddressDelete({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, id)
  // Empty body on success; a plain-string reason when the backend refuses
  // (e.g. the address is still used by inventories). A non-empty string means
  // "blocked" - show that reason instead of a false "deleted" toast.
  if (typeof result === 'string' && result.trim() !== '') {
    Modal.error({ title: 'Cannot delete', content: result, centered: true })
  } else {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_ADDRESS_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_ADDRESSS,
  })
}

function* filterAddress({ searchTerm }) {
  console.log('filterAddress searchTerm', searchTerm)
  const result = yield call(list, 1000000, 0, searchTerm, '%20')
  yield put({
    type: actions.FILTER_ADDRESS_RECIEVED,
    result,
  })
}

function* fetchAddressImport(values) {
  yield put({
    type: actions.REQUESTING,
  })

  const result = yield call(importData, values)
  if (result !== null) {
    if (result.status === 1) {
      notification.success({ message: DEL_200_MSG, description: result.message, duration: 0 })
    } else {
      let errors = ''
      if (result.value && result.value.errors) {
        result.value.errors.map(x => {
          errors += `\n${x.primaryValue}\n`
          errors += `*${x.errorMessages.map(z => z.errorMessage).join('\n')}\n`
          return errors
        })
      }
      Modal.error({
        title: 'Error',
        content: (
          <>
            {result.message}
            {errors.split('\n').map(error => {
              return (
                <>
                  {error}
                  <br />
                </>
              )
            })}
          </>
        ),
        onOk() {},
      })
      // notification.error({
      //   duration: 0,
      //   description: (
      //     <>
      //       {result.message}
      //       <br />
      //       <br />
      //       {errors.split('\n').map(error => {
      //         return (
      //           <>
      //             {error}
      //             <br />
      //           </>
      //         )
      //       })}
      //     </>
      //   ),
      //   message: 'Error',
      // })
    }
  }
  yield put({
    type: actions.RE_FETCH_ADDRESSS,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_ADDRESSS, fetchAddresss),
    takeEvery(actions.FETCH_ADDRESS, fetchAddressEdit),
    takeEvery(actions.SAVE_ADDRESS, fetchAddressSave),
    takeEvery(actions.DELETE_ADDRESS, fetchAddressDelete),
    takeEvery(actions.RE_FETCH_ADDRESSS, fetchAddresssRefresh),
    takeEvery(actions.FILTER_ADDRESS, filterAddress),
    takeEvery(actions.IMPORT_ADDRESS, fetchAddressImport),
  ])
}
